export default __webpack_public_path__ + "static/media/FMS500-LIGHT-P.43493427.png";